/**
 * PBT's `channelType`, chosen by the person composing the broadcast. Mirrors
 * App\Enums\PbtChannelType.
 */
export type PbtChannelType = 'SMS' | 'MMS';

export type PbtMessageType = {
    name: PbtChannelType;
    credits: number;
    maxLength: number;
    allowsMedia: boolean;
    description: string;
};

const MESSAGE_TYPES: Record<PbtChannelType, PbtMessageType> = {
    SMS: {
        name: 'SMS',
        credits: 1,
        maxLength: 160,
        allowsMedia: false,
        description: 'SMS: a single text up to 160 characters, 1 credit per message',
    },
    MMS: {
        name: 'MMS',
        credits: 3,
        maxLength: 1600,
        allowsMedia: true,
        description: 'MMS: up to 1600 characters with optional media, 3 credits per message',
    },
};

/**
 * Whether a texting broadcast goes out as an SMS or an MMS, and what that
 * channel allows. Unknown values fall back to SMS, the column's default.
 */
export function pbtMessageType(channelType: string | null | undefined): PbtMessageType {
    return MESSAGE_TYPES[channelType as PbtChannelType] ?? MESSAGE_TYPES.SMS;
}

/**
 * The length the server measures a message by. Counting code points rather
 * than `String.length` keeps an emoji at one character, matching Laravel's
 * `max` rule (mb_strlen).
 */
export function pbtMessageLength(message: string | null | undefined): number {
    return [...(message ?? '')].length;
}
